<template>
    <div>
        <b-row>
            <b-col>
                <h5 class="text-secondary">Artist</h5>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-input-group size="sm">
                    <b-input v-model="component.first" placeholder="First" class="col-sm-4" :formatter="uppercase"></b-input>
                    <b-input v-model="component.last"
                             placeholder="Last"
                             :state="component && component.last.length ? null : false"
                             :formatter="uppercase"></b-input>
                </b-input-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import objectMixin from "../../mixins/object";
    import formatterMixin from "../../mixins/formatter";

    export default {
        name: "Artist",
        props: [ 'artist' ],
        mixins: [ objectMixin, formatterMixin ],
        created() {
            this.clone(this.artist);
        }
    }
</script>

<style scoped>

</style>